<template>
    <span v-if="file && file.id">
        <a href="javascript:" @click.prevent="downloadFile()">
            <template v-if="iconClass">
                <i :class="iconClass"></i>
            </template>
            <template v-else>скачать</template>            
        </a>
    </span>
</template>

<script>
  import FileAPI from "@/modules/file/api/index";

  export default {
    name: "FileDownload",
    props: {
      file: Object,
      iconClass: String
    },
    methods: {
      downloadFile() {
          var self = this;
        FileAPI.download(self.file.id)
          .then(response => {
              const blob = new Blob([response.data], { type: self.file.fileType });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.target = '_blank';
                link.download = self.file.originalName;
                link.click();
                URL.revokeObjectURL(link.href);
          });
      },
    }
  }
</script>

<style scoped>
</style>